import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appPosition]',
    standalone: false
})
export class PositionDirective {

  @Input('appPosition') positionFromLeft: number;

  constructor(private el: ElementRef) {
  }

  ngOnChanges() {
    this.el.nativeElement.style.left = this.positionFromLeft + "px";
  }
}
